import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Field } from "../../components/FiltersForm/FiltersForm.model";
import useFetchWrapper, { HttpResponse } from "../../Helpers/useFetchWrapper";
import useObjectHelper from "../../Helpers/useObjectHelper";
import { Conference, FilteringTypes, Filters, TabStatus } from "./BackofficeConferences.model";

export const pageSize = 10;

export const useBackofficeConferences = () => {
	const [activeFilters, setActiveFilters] = useState(null);
	const [conferences, setConferences] = useState<Conference[]>();
	const [pagination, setPagination] = useState({ page: 1, size: pageSize, total: 0 });
	const [selectedConference, setSelectedConference] = useState<Conference | undefined>(undefined);
	const [showMobileFilters, setShowMobileFilters] = useState(false);
	const [showAddConferecePopup, setShowAddConferencePopup] = useState(false);
	const [showDeleteConferecePopup, setShowDeleteConferencePopup] = useState(false);
	const [tabStatus, setTabStatus] = useState(TabStatus.Loading);

	const { cleanObj } = useObjectHelper();
	const { get, remove } = useFetchWrapper();

	const intl = useIntl();

	const filterDefaultValues: Record<FilteringTypes, any> = {
		year: null
  }

  const filterFields: Field<Record<FilteringTypes, any>>[] = [{
    label: intl.formatMessage({ id: 'formLabels.year' }),
    name: 'year',
    placeholder: intl.formatMessage({id: 'formPlaceholders.date'}),
    type: 'year',
  }
  ];

	const getFiltersAsQueryParams = (obj: Filters | null) => {
    return obj ? Object.keys(obj).map(key => `${key}=${obj[key]?.year()}`).join('&') : '';
	};

	const deleteConference = async () => {
		const response: HttpResponse<any> = await remove(`/conference/${selectedConference?.id}`);
		if (response.status === 200) {
			setSelectedConference(undefined);
			getConferences();
		}
	}
	const getConferences = async () => {
		setTabStatus(TabStatus.Loading);
		const filters = getFiltersAsQueryParams(activeFilters);
		const response: HttpResponse<{conferences: Conference[], count: number}> = await get(`/conference/all?page=${pagination.page}&size=${pagination.size}&${filters}`);
		if (response.parsedBody) {
			const { conferences, count } = response.parsedBody;
			setConferences(conferences);
			setPagination({ ...pagination, total: count });
			setTabStatus(TabStatus.Loaded);
		}
		else {
			setTabStatus(TabStatus.Error);
		}
	}

	const onChangePagination = (page: number) => {
		setPagination({ ...pagination, page });
	}

	const onResetFilters = (callback?: () => void) => {
		setActiveFilters(null);
		callback && callback();
	}

	const onSubmitFilters = (data: any, callback?: () => void) => {
		setActiveFilters({ ...cleanObj(data) });
		callback && callback();
	}

	const toggle = (set: React.Dispatch<React.SetStateAction<boolean>>, value: boolean) => {
    set(!value);
	}

	useEffect(() => {
		getConferences();
	}, [pagination.page]);

	useEffect(() => {
		if (pagination.page !== 1) setPagination({ ...pagination, page: 1 });
		else getConferences();
	}, [activeFilters])

	return {
		deleteConference,
		filterDefaultValues,
		filterFields,
		getConferences,
		onChangePagination,
		onResetFilters,
		onSubmitFilters,
		setSelectedConference,
		state: {
			conferences,
			pagination,
			selectedConference,
			showAddConferecePopup,
			showDeleteConferecePopup,
			showMobileFilters,
			tabStatus
		},
		toggleAddConferencePopup: () => { toggle(setShowAddConferencePopup, showAddConferecePopup) },
		toggleDeleteConferencePopup: ()=> {toggle(setShowDeleteConferencePopup,showDeleteConferecePopup)},
		toggleMobileFilters: () => { toggle(setShowMobileFilters, showMobileFilters) },
		
	};
}